export default __webpack_public_path__ + "static/media/banner-text.1302578f.png";